<template>
    <div
        class="game-card-wrapper pb-show-display"
        :class="{'game-card-wrapper-line': gameIndex > 0}"
        :data-pblog="pblog"
    >
        <div class="top" @click="gotoHot('other')">
            <div class="img-wrapper" @click.stop="gotoHot('videoClick')">
                <img :src="gameInfo.game_poster" class="img">
                <span :class="`num num-${gameIndex}`">{{ gameIndex + 1 }}</span>
                <span v-if="gameInfo.is_video" class="play-icon"></span>
            </div>
            <div class="info-wrapper" @click.stop="gotoHot('gameInfoClick')">
                <span class="game-name">{{ gameInfo.game_name }}</span>
                <span class="fire-num-wrapper">
                    <i class="fire-icon"></i>
                    <span class="num">{{ hotNum }}</span>
                </span>
                <span v-if="threadNum || memberNum" class="focus">
                    <span v-if="threadNum">关注 {{ threadNum }} </span>
                    <span v-if="memberNum">帖子 {{ memberNum }}</span>
                </span>
            </div>
            <div
                class="download-btn"
                :class="[buttonStatus === 1 ? 'order' : (buttonStatus === 2 ? 'look' : '')]"
                @click.stop="onDownloadClick"
            >
                {{ downloadText }}
            </div>
        </div>
        <div class="bottom" @click.stop="gotoHot('reasonClick')">
            <fire-scroll
                :fire-list="gameInfo.fire_list"
            />
            <div class="reason-mask"></div>
            <!-- <img class="reason_mask" src="https://fenwan.cdn.bcebos.com/cms/gamenow/2022-10/1666604976877/reason-mask.png"> -->
            <div class="operate-btn" @click.stop>
                <img
                    class="fire-btn"
                    :src="fireBg"
                    @click="fireBtnClick('statementClick')"
                >
                <img
                    class="outfire-btn"
                    :src="outfireBg"
                    @click="fireBtnClick('statementClick')"
                >
            </div>
        </div>
    </div>
</template>

<script>
import FireScroll from './app-detail-fire-scroll.vue';
import fireIcon from 'public/assets/imgs/fire-btn.png';
import firedIcon from 'public/assets/imgs/fired-btn.png';
import outfireIcon from 'public/assets/imgs/outfire-btn.png';
import outfiredIcon from 'public/assets/imgs/outfired-btn.png';
import tbNAPI from '@baidu/tb-napi';
import {formatNum} from '@/utils/utility';
import {isIOS} from '@/utils/browser';

export default {
    components: {
        FireScroll,
    },
    props: {
        pageGameInfo: {
            type: Object,
            default: () => {},
        },
        gameInfo: {
            type: Object,
            default: () => {},
        },
        gameIndex: {
            type: Number,
            default: 0,
        },
        curTabId: {
            type: Number,
            default: 1,
        },
        curTagId: {
            type: String,
            default: '',
        },
        curTabName: {
            type: String,
            default: '',
        },
        curTagName: {
            type: String,
            default: '',
        },
        fireBtnAction: {
            type: Number,
            default: 0,
        },
        tiebaInfo: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        hotNum() {
            return formatNum(this.gameInfo.hot_num);
        },
        threadNum() {
            return formatNum(this.gameInfo.thread_num);
        },
        memberNum() {
            return formatNum(this.gameInfo.member_num);
        },
        baseLog() {
            return {
                gameName: this.gameInfo.game_name,
                gameId: this.gameInfo.game_id,
                pageGameName: this.pageGameInfo.game_name,
                pageGameId: this.pageGameInfo.game_id,
                pageGameType: this.pageGameInfo.game_type || '',
                module: 'recommendedModule',
            };
        },
        pblog() {
            return JSON.stringify({
                value: 'gameCardDisplay',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: {
                                ...this.baseLog,
                                btn_status: this.downloadText,
                                tabType: this.curTabName,
                                module: 'recommendedModule',
                            },
                            pos: '',
                        },
                    ],
                },
            });
        },
    },
    data() {
        return {
            ani: null,
            fireBg: this.gameInfo.fire_status === 1 ? firedIcon : fireIcon,
            outfireBg: this.gameInfo.outfire_status === 1 ? outfiredIcon : outfireIcon,
            isInstallApk: false,
            downloadText: '',
            buttonStatus: 0,
        };
    },
    mounted() {
        this.getDownloadBtnTxt();
    },
    methods: {
        checkInstalledByPkgName(pkgName, callBack) {
            if (tbNAPI && tbNAPI.canIUse('system.checkInstallGameApk')) {
                tbNAPI.system.checkInstallGameApk({
                    pkgName: pkgName,
                    success: data => {
                        if (data && data.data) {
                            callBack && callBack(data.data.resultCode === 1);
                        }
                    },
                    fail: data => {
                        if (data && data.data) {
                            callBack && callBack(false);
                        }
                    },
                });
            }
        },
        downloadApk(gameInfo) {
            if (tbNAPI && tbNAPI.canIUse('system.downloadGameApk')) {
                tbNAPI.system.downloadGameApk({
                    gameUrl: gameInfo.download_url,
                    gameId: gameInfo.game_id,
                    pkgName: gameInfo.game_package_name,
                    apkName: gameInfo.game_name,
                    apkIcon: gameInfo.game_icon,
                    forumName: gameInfo.forum_name,
                    apkVersion: gameInfo.apk_version,
                    developerName: gameInfo.developer_name,
                    privacyUrl: gameInfo.privacy_url,
                    authorityUrl: gameInfo.authority_url,
                    packageSize: gameInfo.package_size,
                    versionCode: gameInfo.version_code || 1, // 下载端能力兜底，versionCode至少大于0，否则无法发起下载
                    success: r => {
                        this.$toast('正在下载，去下载管理中查看哦');
                    },
                    fail: r => {
                        console.log(JSON.stringify(r));
                    },
                });
            }
        },
        register() {
            if (tbNAPI && tbNAPI.canIUse('system.orderGameApkResult')) {
                tbNAPI.system.orderGameApkResult({
                    success: result => {
                        if (result && result.data) {
                            const data = result.data;
                            const resCode = data.resultCode;
                            const itemId = data.id;
                            if (itemId === this.gameInfo.item_id && resCode === 1) {
                                this.gameInfo.order_status = 2;
                                this.downloadText = '已预约';
                                this.buttonStatus = 2;
                                this.$toast('预约成功，前往预约管理查看');
                            }
                        }
                    },
                    fail: r => {
                        console.log(JSON.stringify(r));
                        this.$toast('预约失败，请稍候重试');
                    },
                });
            }
        },
        orderApp(itemId, itemName) {
            if (tbNAPI && tbNAPI.canIUse('system.orderGameApk')) {
                tbNAPI.system.orderGameApk({
                    id: itemId,
                    name: itemName,
                    success: r => {
                        console.log(JSON.stringify(r));
                    },
                    fail: r => {
                        console.log(JSON.stringify(r));
                    },
                });
            }
        },
        getDownloadBtnTxt() {
            // 安卓 & 非贴吧端内
            if (!isIOS() && !this.$root.isTiebaApp) {
                if (this.gameInfo.is_publish && this.gameInfo.download_url) {
                    this.downloadText = '下载';
                    this.buttonStatus = 0;
                }
                else {
                    this.downloadText = '查看';
                    this.buttonStatus = 2;
                }
                return;
            }

            if (isIOS()) {
                this.downloadText = '查看';
                this.buttonStatus = 2;
            }
            else {
                if (this.gameInfo.is_publish) {
                    if (this.gameInfo.download_url) {
                        this.checkInstalledByPkgName(this.gameInfo.game_package_name, isInstalled => {
                            if (isInstalled) {
                                this.downloadText = '查看';
                                this.buttonStatus = 2;
                                this.isInstallApk = true;
                            }
                            else {
                                this.downloadText = '下载';
                                this.buttonStatus = 0;
                            }
                        });
                    }
                    else {
                        this.downloadText = '查看';
                        this.buttonStatus = 2;
                    }
                }
                else {
                    if (this.gameInfo.order_status === 1) {
                        this.downloadText = '预约';
                        this.buttonStatus = 1;
                    }
                    else {
                        this.downloadText = '已预约';
                        this.buttonStatus = 2;
                    }
                }
            }
            this.$root.sendLog('display', 'gameBtn_display', {
                btn_status: this.downloadText,
                game_name: this.gameInfo.game_name,
                game_id: this.gameInfo.game_id,
                tabType: this.curTabName,
            });
        },
        jumpPage(url) {
            setTimeout(() => {
                window.location.href = url;
            }, 100);
        },
        onDownloadClick() {
            this.$root.sendLog('click', 'gameBtnClick', {
                btn_status: this.downloadText,
                ...this.baseLog,
                primaryTab: this.curTabId,
                secondaryTab: this.curTagId,
            });
            const jumpUrl = this.combineUrl();

            // 非贴吧端内
            if (!this.$root.isTiebaApp) {
                this.jumpPage(jumpUrl);
            }
            else {
                // 已发布游戏
                if (this.gameInfo.is_publish) {
                    // 有下载链接
                    if (this.gameInfo.download_url && this.gameInfo.download_url.length > 0) {
                        // 校验是否安装游戏
                        this.checkInstalledByPkgName(this.gameInfo.game_package_name, isInstalled => {
                            if (isInstalled) {
                                this.jumpPage(jumpUrl);
                            }
                            else {
                                this.downloadApk(this.gameInfo);
                            }
                        });
                    }
                    else { // 无下载链接，跳转到专区页
                        this.jumpPage(jumpUrl);
                    }
                }
                else { // 游戏未发布
                    if (this.gameInfo.order_status === 1) { // 可预约
                        this.register();
                        this.orderApp(this.gameInfo.item_id, this.gameInfo.item_name);
                    }
                    else {
                        this.jumpPage(jumpUrl);
                    }
                }
            }
        },
        // 组合url
        combineUrl() {
            const params = {
                tabid: this.curTabId,
                tagid: this.curTagId,
                game_id: this.gameInfo.game_id,
            };
            let paramsStr = '';
            Object.keys(params).forEach(item => {
                if (paramsStr === '') {
                    paramsStr = `${item}=${params[item]}`;
                }
                else {
                    paramsStr += `&${item}=${params[item]}`;
                }
            });
            return `${window.location.origin}/static/game/tb-list-activity.html?${paramsStr}`;
        },
        // 给火/灭火按钮点击
        fireBtnClick(type) {
            const url = this.combineUrl();
            this.$root.sendLog('click', type, {
                primaryTab: this.curTabId,
                secondaryTab: this.curTagId,
                btn_status: this.downloadText,
                ...this.baseLog,
            });
            if (this.$root.isTiebaApp) {
                setTimeout(() => {
                    window.location.href = url;
                }, 100);
            }
            else {
                const token = this.$root.getToken(url);
                this.$root.report(token).then(() => {
                    if (+this.fireBtnAction === 2) { // 调起贴吧
                        this.$root.wakeUpTiebaApp(token, url, this.tiebaInfo.android_smart_download_url);
                    }
                    else { // 进入下载中间页
                        window.location.href = this.$root.middlePage;
                    }
                });
            }
        },
        // 前往热力榜页面
        gotoHot(type) {
            this.$root.sendLog('click', type, {
                primaryTab: this.curTabId,
                secondaryTab: this.curTagId,
                ...this.baseLog,
            });
            const url = this.combineUrl();
            setTimeout(() => {
                window.location.href = url;
            }, 100);
        },
    },
};
</script>

<style lang="scss" scoped>
.game-card-wrapper-line {
    border-top: 1px solid #f0f0f0;

}
.game-card-wrapper {
    position: relative;
    z-index: 0;
    padding: 60px 0;
    box-sizing: border-box;
    .top {
        display: flex;
        position: relative;

        .img-wrapper {
            position: relative;
            width: 405px;
            height: 227px;
            border-radius: 27px;

            .img {
                width: 405px;
                height: 227px;
                object-fit: cover;
                border-radius: 27px;
            }

            .num {
                position: absolute;
                top: -1px;
                left: -1px;
                width: 68px;
                height: 72px;
                font-size: 0;
            }

            .num-0 {
                background: url('~public/assets/imgs/num1.png') center center/100% auto no-repeat;
            }

            .num-1 {
                background: url('~public/assets/imgs/num2.png') center center/100% auto no-repeat;
            }

            .num-2 {
                background: url('~public/assets/imgs/num3.png') center center/100% auto no-repeat;
            }

            .num-3 {
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: PingFangSC-Semibold;
                font-size: 45px;
                color: #3388FF;
                font-weight: 600;
                background: url('~public/assets/imgs/new-num3+.png') center center/100% auto no-repeat;
            }

            .play-icon {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background: url('~public/assets/imgs/play.png') center center/100% auto no-repeat;
                width: 90px;
                height: 90px;
            }
        }

        .info-wrapper {
            max-width: 500px;
            height: 227px;
            box-sizing: border-box;
            margin-left: 30px;
            display: flex;
            flex-direction: column;
            padding: 12px 0;

            .game-name {
                font-family: PingFangSC-Medium;
                font-size: 51px;
                color: #1F1F1F;
                line-height: 51px;
                font-weight: 500;
            }

            .fire-num-wrapper {
                display: flex;
                margin-top: 15px;
                height: 51px;
                align-items: center;

                .fire-icon {
                    position: relative;
                    width: 45px;
                    height: 51px;
                    z-index: 2;
                    background: url('~public/assets/imgs/fire-icon.png') center center/100% auto no-repeat;
                }

                .num {
                    background-color: #FEFAD1;
                    border-radius: 0px 12px 12px 0px;
                    height: 45px;
                    display: flex;
                    align-items: center;
                    padding: 0 29px;
                    font-family: PingFangSC-Medium;
                    font-size: 39px;
                    color: #FE820E;
                    line-height: 39px;
                    font-weight: 500;
                    margin-left: -22px;
                }
            }

            .focus {
                margin-top: 51px;
                font-size: 36px;
                color: #b8b8b8;
                line-height: 36px;
            }
        }

        .download-btn {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            height: 84px;
            display: flex;
            align-items: center;
            padding: 0 44px;
            border-radius: 27px;
            font-size: 42px;
            color: #3388FF;
            background: #EFF6FF;
        }

        .order {
            color: #FF6600;
            background-color: rgba(255, 102, 0, 0.08);
        }
    }

    .bottom {
        position: relative;
        width: 100%;
        height: 244px;
        display: flex;
        align-items: center;
        background-color: #f8f8f8;
        border-radius: 27px;
        margin-top: 21px;

        .reason-mask {
            position: absolute;
            right: 392px;
            width: 30px;
            height: 244px;
            background-repeat: no-repeat;
            background-size: 100%;
            background-image: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.06) 100%);
        }

        .operate-btn {
            position: absolute;
            right: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 36px;
            background: #fff;
            height: 100%;
            border-radius: 0px 36px 36px 0px;
            overflow: hidden;
            background-color: #f8f8f8;

            .fire-btn {
                width: 130px;
                height: 157px;
                margin-right: 69px;
            }

            .outfire-btn {
                width: 130px;
                height: 157px;
            }
        }
    }
}
</style>